import { render, staticRenderFns } from "./AlertButton.vue?vue&type=template&id=fe6d77bc&scoped=true"
import script from "./AlertButton.vue?vue&type=script&lang=js"
export * from "./AlertButton.vue?vue&type=script&lang=js"
import style0 from "./AlertButton.vue?vue&type=style&index=0&id=fe6d77bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6d77bc",
  null
  
)

export default component.exports